import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "frenteya_session";

/**
 * Registra una descarga del libro (fire-and-forget, falla silenciosamente).
 * @param {string} source - hero-cta | navbar | book-section | reader-btn
 */
export const trackBookDownload = (source = "unknown") => {
  const sid = localStorage.getItem(SESSION_KEY) || "";
  axios
    .post(`${API}/book/download`, { source, session_id: sid })
    .catch(() => {});
};

export default trackBookDownload;
